import React, { useState } from 'react';

import { Loading } from '../../../components';
import VendorInfo from '../../../components/vendors/VendorInfo';
import { useVendor } from '../../../hooks';
import VendorImages from '../../../hooks/useVendorSearch/VendorImages';
import VendorProducts from '../VendorProducts';

import { StyledContainer } from './styles';
import type { VendorDetailsProps } from './types';

export default function VendorDetails({
  hasPrivateEvents,
  showAllEvents,
}: VendorDetailsProps) {
  const { isLoading, vendor } = useVendor();
  const [currentPickupLocation, setCurrentPickupLocation] =
    useState<OperatingDayLocation>();

  if (isLoading) {
    return (
      <StyledContainer paddingBottom={32}>
        <Loading />
      </StyledContainer>
    );
  }

  if (!vendor) {
    return null;
  }

  return (
    <StyledContainer paddingBottom={32}>
      <VendorImages
        image={vendor.image}
        location="details"
        productImages={vendor.topProductImages}
      />

      <VendorInfo
        data={vendor}
        hasPrivateEvents={hasPrivateEvents}
        showAllEvents={showAllEvents}
        updateCurrentPickupLocation={setCurrentPickupLocation}
      />

      <VendorProducts
        menuId={currentPickupLocation?.productGroupId || vendor.defaultMenu}
        vendorNameId={vendor.nameId}
        css={{
          marginTop: 48,
          '@sm': {
            marginTop: 32,
            padding: '0 16px',
          },
        }}
      />
    </StyledContainer>
  );
}
